import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnmarApiService } from '../anmar-api.service';
import { AnmarBaseListComponent } from '../shared/anmar-base-list.component';
import { ANMAR_RESOURCES } from '../shared/anmar-resources';

@Component({ selector: 'app-anmar-services-list', templateUrl: '../blog/blog-list.component.html', styleUrls: ['../blog/blog-list.component.scss'], encapsulation: ViewEncapsulation.None })
export class AnmarServicesListComponent extends AnmarBaseListComponent {
  config = ANMAR_RESOURCES['services'];
  constructor(api: AnmarApiService, router: Router, toastr: ToastrService) { super(api, router, toastr); }
}
